import { render, staticRenderFns } from "./NoticesBox.vue?vue&type=template&id=43e19be3&"
import script from "./NoticesBox.vue?vue&type=script&lang=js&"
export * from "./NoticesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports